import './index.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import axios from 'axios';
import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';


const rootElement = document.getElementById('root');
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

const appTree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If the server/build already sent real markup inside #root (prerendered HTML),
// hydrate it instead of wiping it out with a fresh client-only render — this is
// React 18's own documented pattern for adopting prerendering incrementally.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, appTree);
} else {
  ReactDOM.createRoot(rootElement).render(appTree);
}

reportWebVitals();
